import angular from 'angular';
import { daysBetween } from '../../tn.licenses/days-between.filter/days-between';
import { hasWebHostedLicense } from '../../tn.licenses/has-license-type.filter/has-web-hosted-license';
import { LicenseService } from '../../tn.licenses/license.service/license-service';
import { PopoverService } from '../../tn.popover/service.tn.popover';
import { LocalProjects } from '../local-projects.service/localProjects';

ProjectsIndex.$inject = ['localProjects', '$tnPopover', 'tnLicenseService'];

export function ProjectsIndex(
    localProjects: LocalProjects,
    $tnPopover: PopoverService,
    licenseService: LicenseService
) {
    const vm = angular.extend(this, {
        projects: localProjects.getFilteredSummaries(),
        webHostedLicenses: false,
        licensesLoaded: false,
        messageLicenses: {
            reachingQuota: {},
            reachedQuota: {},
            expiringLicenses: {},
            expiredLicenses: {},
        },

        //sort binding
        predicate: 'title',
        reverse: 'true',
        setOrder,

        //methods
        deleteProject,
        showDeleteProjectPopover,

        projectToDelete: null,
    });

    initalize();

    function initalize() {
        setOrder('name');
        vm.deleteProjectPopover = $tnPopover.popoverXS(
            angular.element('.popover-projects-delete')
        );
        licenseService.getLicensesFromServer().then((licenses) => {
            vm.webHostedLicenses = hasWebHostedLicense(licenses);
            vm.licensesLoaded = true;
            checkLicensesMessages(licenses);
        });
    }

    function setOrder(predicate) {
        vm.reverse = vm.predicate === predicate ? !vm.reverse : false;
        vm.predicate = predicate;
        vm.caretClass = vm.reverse ? 'icon-caret-down' : 'icon-caret-up';
    }

    function deleteProject($event, project) {
        // XXX: needs to show dropdown
        vm.deleteProjectPopover.hide();
        angular
            .element('.table_row__project' + project.id)
            .fadeOut()
            .promise()
            .done(() => {
                localProjects.deleteProject(project.id);
            });
    }

    function showDeleteProjectPopover($event, project) {
        vm.projectToDelete = project;
        vm.deleteProjectPopover.show($event.currentTarget);
    }

    function checkLicensesMessages(licenses) {
        const reachingQuota = [];
        const reachedQuota = [];
        const expiringLicenses = [];
        const expiredLicenses = [];
        licenses
            .filter((license) => license.fontRights.web)
            .map((license) => {
                const licenseQuota =
                    license.fontRights.web.visits / license.fontRights.web.qty;
                if (
                    license.fontRights.web.end &&
                    daysBetween(license.fontRights.web.end) <= 0
                ) {
                    expiredLicenses.push(license.fontRights.web.id);
                }
                if (licenseQuota >= 1) {
                    reachedQuota.push(license.fontRights.web.id);
                }
                if (
                    license.fontRights.web.end &&
                    daysBetween(license.fontRights.web.end) <= 30
                ) {
                    expiringLicenses.push(license.fontRights.web.id);
                }
                if (0.9 <= licenseQuota && licenseQuota < 1) {
                    reachingQuota.push(license.fontRights.web.id);
                }
            });
        vm.projects.forEach((project) => {
            const licenseIds = project.licenses.map((license) =>
                license.fontRights ? license.fontRights.web.id : license
            );
            vm.messageLicenses.reachingQuota[project.id] = licenseIds.filter(
                (x) => reachingQuota.includes(x)
            ).length;
            vm.messageLicenses.reachedQuota[project.id] = licenseIds.filter(
                (x) => reachedQuota.includes(x)
            ).length;

            vm.messageLicenses.expiringLicenses[project.id] = licenseIds.filter(
                (x) => expiringLicenses.includes(x)
            ).length;
            vm.messageLicenses.expiredLicenses[project.id] = licenseIds.filter(
                (x) => expiredLicenses.includes(x)
            ).length;
        });
    }
}
